<template>
    <div class="iw">
        <img
            class="iw__icon"
            src="@/assets/img/icons/info-gray.svg"
            alt=""
            tabindex="-1"
        />
        <span class="iw__text" v-text="$ml.get('installmentSupportText')" />
    </div>
</template>

<script>
    export default {};
</script>

<style lang="scss" scoped >
    .iw {
        display: flex;
        align-items: center;
        padding: 2px 0;
        margin-top: 6px;

        &__icon {
            margin-right: 4px;
        }

        &__text {
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            color: #5C6A7B;
        }
    }
</style>